/*
import { S as Swiper } from './shared/swiper-core.mjs';
import Virtual from './modules/virtual.mjs';
import Keyboard from './modules/keyboard.mjs';
import Mousewheel from './modules/mousewheel.mjs';
import Navigation from './modules/navigation.mjs';
import Pagination from './modules/pagination.mjs';
import Scrollbar from './modules/scrollbar.mjs';
import Parallax from './modules/parallax.mjs';
import Zoom from './modules/zoom.mjs';
import Controller from './modules/controller.mjs';
import A11y from './modules/a11y.mjs';
import History from './modules/history.mjs';
import HashNavigation from './modules/hash-navigation.mjs';
import Autoplay from './modules/autoplay.mjs';
import Thumb from './modules/thumbs.mjs';
import freeMode from './modules/free-mode.mjs';
import Grid from './modules/grid.mjs';
import Manipulation from './modules/manipulation.mjs';
import EffectFade from './modules/effect-fade.mjs';
import EffectCube from './modules/effect-cube.mjs';
import EffectFlip from './modules/effect-flip.mjs';
import EffectCoverflow from './modules/effect-coverflow.mjs';
import EffectCreative from './modules/effect-creative.mjs';
import EffectCards from './modules/effect-cards.mjs';
*/

// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, Scrollbar, Parallax, Zoom, Thumbs, EffectSlide, EffectFade, EffectCube, EffectFlip, EffectCoverflow, EffectCreative, EffectCards } from 'swiper/modules';
window.Swiper = Swiper;
//window.SwiperModules = {Autoplay, Navigation, Pagination, Scrollbar, Parallax, Zoom, Thumbs, EffectFade, EffectCube, EffectFlip, EffectCoverflow, EffectCreative, EffectCards};

Swiper.use([Autoplay, Navigation, Pagination, Scrollbar, Parallax, Zoom, Thumbs, EffectFade, EffectCube, EffectFlip, EffectCoverflow, EffectCreative, EffectCards]);

const homeslider = new Swiper('.homeswiper', {
    modules: [Autoplay, Navigation, Pagination,EffectCards],
    //effect: "slide",
    effect: "cards",
    grabCursor: true,
    
    speed: 700,

    
    loop: true,
    autoplay: {
        delay: 300000,
    },
    pagination: {
      el: ".swiper-pagination",
    },
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
});

var homesliderOspitalita = new Swiper ('.homeswiper-ospitalita', {
    modules: [Autoplay, Navigation, Pagination],
    direction: "horizontal",
    slidesPerView: 2.5,
    spaceBetween: 30,
    loop: true,
    autoHeight: true,
    speed: 5000,
    freeMode: true,

    autoplay: {
        delay: 1,
    },

    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },

    breakpoints: {
        992: {
            direction: "vertical",
        }
    }
})

var homesliderOspitalitaSec = new Swiper ('.homeswiper-ospitalita-sec', {
    modules: [Autoplay, Navigation, Pagination],
    direction: "horizontal",
    slidesPerView: 2.5,
    spaceBetween: 30,
    loop: true,
    autoHeight: true,
    speed: 5000,
    freeMode: true,

    autoplay: {
        delay: 1,
        reverseDirection: true,
    },

    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },

    breakpoints: {
        992: {
            direction: "vertical",
        }
    }
})


var productenSwiper = new Swiper ('.producten-slider-swiper', {
    slidesPerView: 3.2,
    slidesPerGroup: 1,
    a11y: false,
    spaceBetween: 22,
    allowTouchMove: true,
    
    breakpoints: {
        0: { /* when window >=0px - webflow mobile landscape/portriat */
        slidesPerView: 1.2,
        slidesPerGroup:1,
        spaceBetween: 22,
        },
        480: { /* when window >=0px - webflow mobile landscape/portriat */
        slidesPerView: 1.2,
        slidesPerGroup:1,
        spaceBetween: 22,
        },
        767: { /* when window >= 767px - webflow tablet */
        slidesPerView: 2.2,
        slidesPerGroup:1,
        spaceBetween: 22,
        },
        992: { /* when window >= 988px - webflow desktop */
        slidesPerView: 3.2,
        slidesPerGroup:1,
        spaceBetween: 22,
        }
    },
});

// Knopacties voor producten-slider-swiper
document.querySelectorAll('.producten-slider-swiper-holder .swiper-button-prev').forEach(function(button) {
    button.addEventListener('click', function() {
        var slider = this.closest('.producten-slider-swiper-holder').querySelector('.producten-slider-swiper');
        slider.swiper.slidePrev();
    });
});
document.querySelectorAll('.producten-slider-swiper-holder .swiper-button-next').forEach(function(button) {
    button.addEventListener('click', function() {
        var slider = this.closest('.producten-slider-swiper-holder').querySelector('.producten-slider-swiper');
        slider.swiper.slideNext();
    });
});




document.addEventListener('DOMContentLoaded', function() {
  var logoAndTeamSliders = document.querySelectorAll('.overview_logos .swiper-container, .overview_team .swiper-container, .mediaslider .swiper-container');

  logoAndTeamSliders.forEach(function(slider) {
    console.log('slider container gevonden:', slider);

    var columnsLarge = parseInt(slider.getAttribute('data-columns_large'), 10) || 3;
    var columnsMedium = parseInt(slider.getAttribute('data-columns_medium'), 10) || 2;
    var columnsSmall = parseInt(slider.getAttribute('data-columns_small'), 10) || 1;
    var spaceBetween = parseInt(slider.getAttribute('data-space_between'), 10) || 20;
    var speed = parseInt(slider.getAttribute('data-speed'), 10) || 300;
    var autoplay = (String(slider.getAttribute('data-auto_play')).toLowerCase() === 'true') || false;

    var autoplayDelayAttr = slider.getAttribute('data-auto_play_delay');
    var autoplayDelay = autoplayDelayAttr !== null ? parseInt(autoplayDelayAttr, 10) : 2000;

    var loop = (String(slider.getAttribute('data-loop')).toLowerCase() === 'true') || true;

    // Debugging to check values
    console.log('columnsLarge:', columnsLarge);
    console.log('columnsMedium:', columnsMedium);
    console.log('columnsSmall:', columnsSmall);
    console.log('spaceBetween:', spaceBetween);
    console.log('speed:', speed);
    console.log('autoplay:', autoplay);
    console.log('autoplayDelay:', autoplayDelay);
    console.log('loop:', loop);

    var container = slider.closest('.section');

    if (!container) {
      console.error('Container niet gevonden voor slider:', slider);
      return;
    }

    var nextButton = container.querySelector('.swiper-button-next');
    var prevButton = container.querySelector('.swiper-button-prev');

    if (!nextButton || !prevButton) {
      console.error('Navigatieknoppen niet gevonden voor container:', container);
      return;
    }

    var swiperOptions = {
      modules: [Autoplay, Navigation, Pagination],
      slidesPerView: columnsSmall,
      spaceBetween: spaceBetween,
      speed: speed,
      loop: loop,
      autoplay: autoplay ? {
        delay: autoplayDelay,
        disableOnInteraction: false
      } : false,
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      breakpoints: {
        768: {
          slidesPerView: columnsMedium
        },
        1024: {
          slidesPerView: columnsLarge
        },
      },
    };

    new Swiper(slider, swiperOptions);
  });
});










// var swiperContainer = document.querySelector('.overview_logos .swiper-container');

// var overviewLogosSwiper = new Swiper('.overview_logos .swiper-container', {
//   modules: [Autoplay, Navigation, Pagination],
//   slidesPerView: parseInt(overviewLogosSwiper.getAttribute('data-columns_large'), 10) || 3,
//   spaceBetween: parseInt(overviewLogosSwiper.getAttribute('data-space_between'), 10) || 10,
//   speed: parseInt(overviewLogosSwiper.getAttribute('data-speed'), 10) || 300,

//   autoplay: overviewLogosSwiper.getAttribute('data-auto_slide') ? {
//     delay: parseInt(overviewLogosSwiper.getAttribute('data-slide_interval'), 10) || 300,
//     disableOnInteraction: false
//   } : false,
//   pagination: {
//     el: overviewLogosSwiper.querySelector('.swiper-pagination'),
//     clickable: true,
//   },
//   navigation: {
//     nextEl: overviewLogosSwiper.querySelector('.swiper-button-next'),
//     prevEl: overviewLogosSwiper.querySelector('.swiper-button-prev'),
//   },
// });

